import flatpickr from 'flatpickr';
import type { Instance as FlatpickrInstance } from 'flatpickr/dist/types/instance';

export function resetButton(
  elementFrom: FlatpickrInstance,
  elementTo: FlatpickrInstance,
  fromDate: Date,
  toDate: Date
): HTMLAnchorElement | false {
  const resetButton = document.querySelector('[mscc-field="reset"]') as HTMLAnchorElement;
  console.log('Found Reset Button', resetButton);
  if (resetButton) {
    resetButton.onclick = () => {
      console.log('Reset Button Clicked');
      elementFrom.setDate(flatpickr.formatDate(fromDate, 'Y-m-d'));
      elementTo.setDate(flatpickr.formatDate(toDate, 'Y-m-d'));
      console.log('Dates Reset', { fromDate, toDate });
      resetButton.dispatchEvent(new Event('input'));
      console.log('Input Event Dispatched');
      elementFrom.close();
      elementTo.close();
      console.log('Flatpickr Closed');
      return false;
    };
  }
  return resetButton;
}
